import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { ArticleView, getArticleOptions } from '@/module/Author/Article';

export const Route = createFileRoute('/_auth/author/_author/article/_article/$articleId/_layout/')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.view' },
  },
});

function RouteComponent() {
  const { articleId } = Route.useParams();
  const { data: article } = useSuspenseQuery(getArticleOptions(articleId));

  return <ArticleView article={article} />;
}
